import axios from './axios';

const getECommerceInfo = (currentLanguage) => {
  return axios.get('/api/store/eCommerceInfo', {
    headers: {
      'Accept-Language': currentLanguage,
    },
  });
};

const getEmojiProductDetail = (productId) => {
  return axios.get('/api/store/emoji/product', {
    params: { productId },
  });
};

export { getECommerceInfo, getEmojiProductDetail };
